module.exports = __webpack_public_path__ + "Averta-Light.836e325e20aca9975d9c.woff";


//////////////////
// WEBPACK FOOTER
// /Users/nolanclark/Desktop/Development/GoPark/src/fonts/Averta-Light.woff
// module id = ../../../../../src/fonts/Averta-Light.woff
// module chunks = styles